import EntityModel from '@/common/models/entity-model';

export default class CreateKeapInfusionsoftPaymentModel extends EntityModel {
    hydrate({
        name = null,
        paymentBody = null,
        credentialHash = null,
    } = {}) {
        this.name = name;
        this.paymentBody = paymentBody;
        this.credentialHash = credentialHash;
    }

    getPayload() {
        return {
            name: this.name,
            paymentBody: this.paymentBody,
            credentialHash: this.credentialHash,
        };
    }
}
